import React from "react";
import SlideCard from "./SlideCard";

const SliderHome = () => {
  const imgHome = [
    // "./images/Slide/slideshow_0.png",
    "./images/Slide/slideshow_1.png",
    "./images/Slide/slideshow_2.jpg",
    "./images/Slide/slideshow_3.jpg",
    "./images/Slide/slideshow_4.jpg",
  ];
  return (
    <section className="mb-5">
      <div>
        <SlideCard imgRender={imgHome} />
      </div>
    </section>
  );
};

export default SliderHome;
